import React from 'react';
import cn from 'classnames';

import {IGridRowProps} from './IGridRow';

const GridRow = (props: IGridRowProps) => {
	const attrs: {className: string; style?: React.CSSProperties} = {
		className: cn('row', props.classNames, {
			[`g-y-${props.verticalGutters}`]: !!props.verticalGutters,
			[`g-x-${props.horizontalGutters}`]: !!props.horizontalGutters,
			[`row--h-borders`]: !!props.horizontalBorders,
		}),
	};

	if (props.style) {
		attrs.style = props.style;
	}

	if (props.edgeToEdge) {
		attrs.className += ' edge-to-edge';
	}

	return <div {...attrs}>{props.children}</div>;
};

export default GridRow;
